import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { sel, selW } from "./shared";

const Pick = ({ label, emps, value, onChange, tid }) => {
  const [q, setQ] = useState("");
  const list = emps.filter((e) => e.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid={tid}>
      <div className="flex items-center justify-between mb-2"><div className="text-sm font-semibold text-slate-800">{label}</div><span className="text-[11px] text-slate-500">{value.length} assigned</span></div>
      <Input placeholder="Search employee…" value={q} onChange={(e) => setQ(e.target.value)} className="h-8 mb-2" />
      <div className="max-h-56 overflow-y-auto divide-y divide-slate-100">
        {list.map((e) => <label key={e.id} className="flex items-center gap-2 py-1.5 text-xs cursor-pointer"><input type="checkbox" checked={value.includes(e.id)} onChange={(ev) => onChange(ev.target.checked ? [...value, e.id] : value.filter((x) => x !== e.id))} /><span className="text-slate-800">{e.name}</span><span className="ml-auto text-[10px] text-slate-400">{e.department}</span></label>)}
      </div>
    </div>
  );
};

export const RolesTab = ({ meta }) => {
  const [cid, setCid] = useState(meta.companies[0]?.id || "");
  const [roles, setRoles] = useState([]);
  const [emps, setEmps] = useState([]);
  const [allEmps, setAllEmps] = useState([]);
  const [f, setF] = useState({ adco: [], adrc: [], hdco: [] });
  useEffect(() => { api.get("/dms/roles").then(({ data }) => setRoles(data)); api.get("/dms/employees").then(({ data }) => setAllEmps(data)); }, []);
  useEffect(() => { if (cid) api.get(`/dms/employees?company_id=${cid}`).then(({ data }) => setEmps(data)); }, [cid]);
  useEffect(() => {
    const r = roles.find((x) => x.company_id === cid) || {};
    const h = roles.find((x) => x.company_id === "HOLDINGS") || {};
    setF({ adco: r.adco || [], adrc: r.adrc || [], hdco: h.hdco || [] });
  }, [cid, roles]);
  const save = async (company_id, body) => {
    try { await api.put("/dms/roles", { company_id, ...body }); toast.success("DMS roles saved"); const { data } = await api.get("/dms/roles"); setRoles(data); } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  return (
    <div className="space-y-5" data-testid="dms-roles">
      <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4 space-y-3">
        <div className="flex flex-wrap items-center gap-2"><div className="text-sm font-semibold text-slate-800">Per company</div><select className={`${selW} w-full sm:w-72`} value={cid} onChange={(e) => setCid(e.target.value)} data-testid="roles-company">{meta.companies.map((c) => <option key={c.id} value={c.id}>{c.name}{c.code ? ` (${c.code})` : ""}</option>)}</select><Button onClick={() => save(cid, { adco: f.adco, adrc: f.adrc })} className="sm:ml-auto bg-blue-600 hover:bg-blue-700" data-testid="roles-save-company">Save company roles</Button></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Pick label="Applicable Document Control Officer (ADCO)" emps={emps} value={f.adco} onChange={(adco) => setF({ ...f, adco })} tid="roles-adco" />
          <Pick label="Applicable DRC (can request copies)" emps={emps} value={f.adrc} onChange={(adrc) => setF({ ...f, adrc })} tid="roles-adrc" />
        </div>
      </div>
      <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4 space-y-3">
        <div className="flex items-center gap-2"><div className="text-sm font-semibold text-slate-800">Holdings DCO (whole group)</div><Button onClick={() => save("HOLDINGS", { hdco: f.hdco })} className="ml-auto bg-blue-600 hover:bg-blue-700" data-testid="roles-save-hdco">Save Holdings DCO</Button></div>
        <div className="max-w-xl"><Pick label="Holdings Document Control Officer" emps={allEmps} value={f.hdco} onChange={(hdco) => setF({ ...f, hdco })} tid="roles-hdco" /></div>
      </div>
    </div>
  );
};
